export const transformOccasion = (occasion: string) => ({ Title: occasion });
